import React from "react";
import play7 from "../../../images/achievementimage/play7.jpeg"
import goal2 from "../../../images/achievementimage/goal2.jpeg"
import ach1 from "../../../images/achievementimage/ach1.jpeg"
const AchievementSection3 = () => {
  return (
    <div className=" mx-5 justify-between pt-40 lg:mx-auto lg:flex lg:w-[80%]">
      <div className="mx-44 hidden w-[45%] lg:relative lg:mx-0 lg:block">
        <div className=" ">
          <img
            className="h-full w-full min-w-min lg:object-fill lg:h-[60vh] rounded-3xl "
            src={goal2}
            alt=""
          />
        </div>
        <div className="absolute -bottom-20 -right-24 h-3/4 w-3/4 bg-white rounded-3xl">
          <div className="float-left w-[90%] border rounded-3xl ">
            <img
              className="h-96 rounded-3xl"
              src={ach1}
              alt=""
            />
            <a
              className="video-popup"
              href="https://www.youtube.com/watch?v=FjGu7QyfueY"
            ></a>
          </div>
        </div>
      </div>
      <div className="h-1/2 border-4 border-y-blue-400 border-x-blue-400 pb-32 lg:w-[50%]">
        <h1 className="mx-6 lg:mt-28 mt-10 lg:text-5xl text-3xl font-bold">HOW TO ACHIEVE GOAL ?</h1>
        <h2 className="mx-6 mt-7 text-2xl text-gray-500">
          When establishing goals, it is important to remember the{" "}
          <a className="text-black font-bold"> 4 P's</a> of goal setting. They need
          to be positive, personal, possible, and prioritized.
        </h2>
        <p className="mx-6 mt-9 text-xl ">
          Be Passionate &emsp;|&emsp; Work Hard &emsp;|&emsp; Be Good
          &emsp;|&emsp; Be Persistent &emsp;|
          <br />
          Push the Limits &emsp;|&emsp; Serve &emsp; |&emsp; Create Ideas
          &emsp;| &emsp; Focus&emsp;|
        </p>
        <div className=" mt-5 mx-7  lg:text-center ">
        <button className=" mx-2 mt-10 cursor-pointer bg-blue-400 px-4 py-4 text-xl font-bold text-black hover:bg-black hover:text-white">
          G
        </button>
        <button className=" mx-2 mt-10 cursor-pointer bg-blue-400 px-4 py-4 text-xl font-bold text-black hover:bg-black hover:text-white">
          O
        </button>
        <button className="mx-2 mt-10 cursor-pointer bg-blue-400 px-4 py-4 text-xl font-bold text-black hover:bg-black hover:text-white">
          A
        </button>
        <button className="mx-2 mt-10 cursor-pointer bg-blue-400 px-4 py-4 text-xl font-bold text-black hover:bg-black hover:text-white">
          L
        </button>
        </div>
      </div>
    </div>
  );
};

export default AchievementSection3;
